"use client";
import { Button } from "@cappelendamm/design-system/react";
import { PAYMENT_PROVIDERS } from "@cappelendamm/e-commerce-services";
import { useFormContext, useWatch } from "react-hook-form";

type CheckoutSubmitProps = {
  isPending?: boolean;
  isTotalZero?: boolean;
  disabled?: boolean;
};

export const CheckoutSubmit = ({
  isPending,
  isTotalZero,
  disabled,
}: CheckoutSubmitProps) => {
  const paymentType = useWatch({ name: "payment.type" });
  const {
    formState: { isSubmitting },
  } = useFormContext();

  let text;
  switch (true) {
    case isTotalZero:
      text = "Bestill nå – gratis";
      break;

    case paymentType === PAYMENT_PROVIDERS.NETS:
      text = "Fullfør";
      break;

    default:
      text = "Bestill";
  }
  return (
    <Button
      id="submit-payment"
      className="w-full cursor-pointer py-3"
      disabled={isPending || isSubmitting || disabled}
      type="submit"
    >
      {text}
    </Button>
  );
};
